import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectLayout, THEME } from './store/layout/layoutSlice';
import { useAuth0 } from '@auth0/auth0-react';
import { Routes } from './routes/Routes';
import { authService } from './services/auth/authService';
import { setUser } from './store/user/userSlice';
import { useNavigate, useLocation } from 'react-router-dom';

const AppContent = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const isInitialLogin = useRef(true);
    const {
        getAccessTokenSilently,
        getIdTokenClaims,
        isAuthenticated,
        user,
        isLoading,
    } = useAuth0();
    const layout = useSelector(selectLayout);
    const dispatch = useDispatch();

    useEffect(() => {
        authService.setGetTokenFn(() => getAccessTokenSilently());
    }, [getAccessTokenSilently]);

    useEffect(() => {
        if (layout.theme === THEME.DARK) {
            document.documentElement.classList.add('dark');
        } else {
            document.documentElement.classList.remove('dark');
        }
    }, [layout.theme]);

    useEffect(() => {
        const syncUser = async () => {
            if (isAuthenticated && user) {
                const accessToken = await getAccessTokenSilently();
                const idTokenClaims = await getIdTokenClaims();

                const userData = {
                    email: user.email || '',
                    accessToken,
                    idToken: idTokenClaims?.__raw || '',
                    name: user.name || '',
                    emailVerified: user.email_verified || false,
                    nickname: user.nickname || '',
                    picture: user.picture || '',
                    sub: user.sub || '',
                    updatedAt: user.updated_at || '',
                };

                dispatch(setUser(userData));

                if (isInitialLogin.current && location.pathname === '/') {
                    navigate('/dashboard');
                    isInitialLogin.current = false;
                }
            }
        };

        if (!isLoading) {
            syncUser();
        }
    }, [
        isAuthenticated,
        user,
        isLoading,
        getAccessTokenSilently,
        getIdTokenClaims,
        dispatch,
        navigate,
        location.pathname,
    ]);

    return <Routes />;
};

export default AppContent;
